import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = '[data-product-card]';
const PLUGIN_NAME = 'productCard';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "product-card" */ "./product-card"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/product-card/index--split.js